var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$href())?_c('a',{attrs:{"href":_vm.$href(),"rel":_vm.$rel()},on:{"click":function($event){return _vm.$onClick()}}},[_c('common-icon',{attrs:{"spec":_vm.iconSpec}})],1):_c('common-icon',{attrs:{"spec":_vm.iconSpec}})}
var staticRenderFns = []

export { render, staticRenderFns }